



import { Component, Prop, Vue } from "vue-property-decorator";
import { routes } from "@/router";

const coms: any = {};
routes.forEach((v) => {
	coms[v.name] = v.component;
});

@Component({
	components: coms,
})
export default class Tabs extends Vue {
	@Prop({ type: String, required: true })
	url!: string;

	get componentName() {

        for (let i = 0; i < routes.length; i++) {
            const v = routes[i];
            if (v.path.toLowerCase() === this.url.toLowerCase()) return v.name;
        }
		return null;
	}
}
